// extracted by mini-css-extract-plugin
module.exports = {"markdown":"_704c034e"};